// Web fonts (self-hosted, не CDN — customer install может быть offline)
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import '@fontsource/jetbrains-mono/600.css'

// Design tokens — должны быть импортированы первыми, до Naive UI и компонентов
import '@/styles/tokens.css'
import '@/styles/base.css'
import 'highlight.js/styles/github.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import App from './App.vue'
import { router } from './router'
import { useAuthStore } from './stores/auth'
import { setupApiClient } from './api/client'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 30_000,
      refetchIntervalInBackground: false,
    },
  },
})
app.use(VueQueryPlugin, { queryClient })

const authStore = useAuthStore()
authStore.hydrate()
setupApiClient(router, authStore)

app.mount('#app')
